/**
 * Created with IntelliJ IDEA.
 * User: orenm
 * Date: 4/19/15
 * Time: 6:53 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseRouterController = require("controllers/BaseRouterController");
    var ConnectionRouteController;

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        ConnectionRouteController = BaseRouterController.extend({
            navigation: {
                routes:{
                    "iframe": {
                        callback: "onIframeShow",
                        auth: {
                            privileges: []
                        }
                    }
                },
                defaultRoute:"iframe"
            },

            //handler definitions
            onIframeShow:function () {
                if(_.isObject(LEConnection.contextModel)){
                    LEConnection.contextModel.set("iframeWrapper", true);
                }
            }
        });
    });

    return ConnectionRouteController;
});
